declare var window: any;
declare var angular: any;

import * as moment from 'moment';

angular
  .module('GlobalControllers')

  .controller('AppCtrl', [
    '$route',
    '$location',
    '$scope',
    '$http',
    'pricing',
    'navbar',
    'api',
    '$mdToast',
    'audio',
    '$anchorScroll',
    '$mdMedia',
    'EXAM',
    'exam',
    'ENVIRONMENT',
    '$mdDialog',
    'angularPlayer',
    '$translate',
    'lang',
    function(
      $route,
      $location,
      $scope,
      $http,
      pricing,
      navbar,
      api,
      $mdToast,
      audio,
      $anchorScroll,
      $mdMedia,
      EXAM,
      exam,
      ENVIRONMENT,
      $mdDialog,
      angularPlayer,
      $translate,
      lang
    ) {
      var getParams = $location.search();
      if (getParams && getParams.r) {
        var referral = getParams.r;
        if (referral === 'fnac') {
          referral = 31211;
        } else {
          referral = +referral;
        }

        localStorage.setItem('referral', referral);
      }

      $scope.main = {
        theme: EXAM,
        exam: EXAM,
        environment: ENVIRONMENT
      };

      $scope.lang = lang;

      $scope.examData = exam.examData;

      $scope.main.urlClick = function(href) {
        console.log('href', href);
        $location.url(href);
      };

      $scope.main.showPrices = function() {
        pricing.showPrices();
      };

      var _computeRoles = function(meData) {
        var roles = [];
        if (meData.profile.is_manager) {
          roles.push('manager');
        }
        if (meData.profile.is_teacher) {
          roles.push('teacher');

          roles.push('user');
        }

        if (roles.length === 0) {
          roles.push('user');
        }

        return roles;
      };

      var _computeFirstTime = function(meData) {
        if ($scope.main.me.firstTime === false) return false;

        return meData.profile.time_spent === 0;
      };

      var _computeIsPremium = function(meData) {
        return moment
          .utc(meData.profile.expiration_date)
          .isAfter(moment.utc().add(5, 'minute'));
      };

      var _computeMock = function(meData) {
        return meData.plans && meData.plans.length > 0;
      };

      const rolesTranslations = {
        manager: {
          fr: 'administrateur',
          en: 'administrator'
        },
        teacher: {
          fr: 'formateur',
          en: 'teacher'
        },
        user: {
          fr: 'apprenant',
          en: 'learner'
        }
      };

      $scope.translateRoles = function(role) {
        return rolesTranslations[role][lang.key];
      };

      $scope.$watch(
        function() {
          return api.data.me;
        },
        function(newVal, oldVal) {
          if (newVal && newVal?.user?.email === oldVal?.user?.email) {
            newVal.current_role = $scope?.main?.me?.current_role;
          }
          $scope.main.me = newVal;
          if (newVal) {
            $scope.main.me.current_role = $scope.main.me.current_role || 0;
            $scope.main.me.roles = _computeRoles(newVal);
            $scope.main.me.firstTime = _computeFirstTime(newVal);
            $scope.main.me.isPremium = _computeIsPremium(newVal);
            $scope.main.me.mock = _computeMock(newVal);
          }
        },
        true
      );
      api.sync(api.me);

      $scope.$watch(
        function() {
          return navbar.navbar;
        },
        function(newVal, oldVal) {
          $scope.main.navbar = newVal;
        },
        true
      );

      $scope.$on('sound:alert', function(event, data) {
        $mdDialog
          .show(
            $mdDialog
              .confirm()
              .parent(angular.element(document.body))
              .clickOutsideToClose(true)
              .title('On a rencontré un problème pour charger le fichier audio')
              .htmlContent(
                `Différentes causes peuvent être à l'origine de ce problème rencontré.<br>Vous avez un problème de connexion ou votre ordinateur a bloqué le chargement du fichier audio`
              )
              .ok('Passer en mode dégradé')
              .cancel("Ré-essayer de charger l'audio")
          )
          .then(
            () => {
              $scope.main.audioDegraded = true;
            },
            () => {
              angularPlayer.play();
            }
          );
      });

      $scope.$on('$routeChangeSuccess', function(event, current) {
        if ((window as any).Intercom) {
          (window as any).Intercom('update');
        }

        if ((window as any).fbq) {
          (window as any).fbq('track', 'PageView');
        }

        audio.stop();

        var url = $location.url();

        switch (url) {
          case '/':
            navbar.menu(0);
            break;

          case '/training':
          case '/entrainement':
          case '/m/students':
          case '/t/students':
            navbar.menu(1);
            break;

          case '/exam':
          case '/examen':
          case '/m/teachers':
          case '/t/spheres':
            navbar.menu(2);
            break;

          case '/lesson':
          case '/cours':
          case '/t/toeic':
          case '/t/exam':
            navbar.menu(3);
            break;

          case '/lexicon':
          case '/correction':
          case '/glossaire':
          case '/t/bright':
          case '/t/correction':
          case '/m/spheres':
            navbar.menu(4);
            break;
          case '/m/institutions':
            navbar.menu(5);
            break;
        }
      });

      $scope.scrollTo = function(id) {
        $anchorScroll(id);
      };

      $scope.swipe = function(side) {
        if (
          $mdMedia('xs') &&
          $scope.main.me.roles &&
          $scope.main.navbar.current !== 'back'
        ) {
          if (side == 'right') {
            $scope.main.navbar.currentMenu = $scope.main.navbar.currentMenu - 1;
          }
          if (side == 'left') {
            $scope.main.navbar.currentMenu = $scope.main.navbar.currentMenu + 1;
          }
        }
      };
    }
  ]);
